<template>
  <div v-if="show" class="messageContainer">
    <div class="messageBox" :class="boxClass">
      <font-awesome-icon class="messageIcon" :class="iconClass" :icon="faIcon" />
      <h1>{{ computedTitle }}</h1>
      <div class="lineDiv" />
      {{ message }}
      <font-awesome-icon @click="show = false" class="closeButton" :icon="['fas', 'xmark']" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'MessageModal',
  props: {
    message: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      default: 'error',
      validator: (val) => ['error', 'success', 'info'].includes(val),
    },
  },
  data() {
    return {
      show: false,
    };
  },
  computed: {
    computedTitle() {
      if (this.type === 'success') return 'Success!';
      if (this.type === 'info') return 'Notice!';
      return 'Error!';
    },
    boxClass() {
      switch (this.type) {
        case 'success':
          return 'successBox';
        case 'info':
          return 'infoBox';
        default:
          return 'errorBox';
      }
    },
    iconClass() {
      switch (this.type) {
        case 'success':
          return 'successIcon';
        case 'info':
          return 'infoIcon';
        default:
          return 'errorIcon';
      }
    },
    faIcon() {
      switch (this.type) {
        case 'success':
          return ['fas', 'check'];
        case 'info':
          return ['fas', 'exclamation'];
        default:
          return ['fas', 'xmark'];
      }
    },
  },
  methods: {
    open(timeout = 4000) {
      this.show = true;
      setTimeout(() => {
        this.show = false;
      }, timeout);
    },
  },
};
</script>

<style scoped>
.messageContainer {
  position: fixed;
  width: 100%;
  top: var(--header-height);
  left: 0;
  z-index: 1000;
  display: flex;
  justify-content: center;
}

.messageBox {
  width: calc(100% - 30px);
  border-radius: 12px;
  color: var(--text-primary);
  padding: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  margin: 15px 30px;
  max-width: 600px;
  text-align: center;
  background-color: var(--color-card);
  position: relative;
}

/* Error styling */
.errorIcon {
  background: linear-gradient(180deg, #e54444, #ce2626);
  border: 4px solid var(--error-red-border);
  width: 50px;
  height: 50px;
  border-radius: 50%;
  padding: 10px;
  margin-bottom: 30px;
}

/* Success styling */
.successIcon {
  background: linear-gradient(203.2deg, #a7cc18, #77b90e 50%, #77b90e 75%);
  border: 4px solid #2f9e00;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  padding: 10px;
  margin-bottom: 30px;
}

/* Info styling */
.infoIcon {
  background-color: var(--info-blue);
  border: 4px solid var(--info-blue-border);
  width: 50px;
  height: 50px;
  border-radius: 50%;
  padding: 10px;
  margin-bottom: 30px;
}

/* Example CSS variable definitions (add these in a global file or :root):
   --error-red: #e53e3e;
   --error-red-border: #c53030;
   --success-green: #48bb78;
   --success-green-border: #38a169;
   --info-blue: #3182ce;
   --info-blue-border: #2b6cb0;
*/
</style>
